import type { BFFArticleDetail } from "@src/app/types/bff";
import { type ReactElement } from "react";

type Props = Readonly<{
  translator: BFFArticleDetail["translator"];
  className?: string;
}>;

export default function TranslatorCard({
  translator,
  className,
}: Props): ReactElement {
  return (
    <div
      data-testid="translator-card"
      className={`text-label-1 text-tertiary font-bold ${className}`}
    >
      <span>Translated by</span>
      <span>{" " + translator}</span>
    </div>
  );
}
